export default __webpack_public_path__ + "static/media/indoor-tracking.21b552ff.jpg";